import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Col,
  Row,
  ControlLabel,
  ListGroup,
  ListGroupItem,
  Button,
} from "react-bootstrap";
import Card from "../../../components/Card/Card";
import TextFieldGroup from "../../../components/TextFieldGroup/TextFieldGroup.js";
import Loading from "../../../views/Loading";
import { Multiselect } from "multiselect-react-dropdown";
import {
  produccion,
  compras,
  ventas,
  autorizaciones,
  fracttal,
  logistica,
  bodega
} from "../../../variables/constantesReportes";
import Swal from 'sweetalert2';  // Importa SweetAlert2
import { dominio } from "../../../routes_backend/routes.jsx";


// import { rutas } from "../../../routes_backend/routes";

class addUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      isLoading: false,
      nombre: "",
      apellido: "",
      email: "",
      cargo: "",
      is_description: "seleccione un usuario",
      showHome: false,
      showProduction: false,
      showVentas: false,
      showCompras: false,
      showAutorizaciones: false,
      showFracttal: false,
      showLogistica: false,
      showBodega: false,

      listProduction: [],
      ListVentas: [],
      ListCompras: [],
      ListAutorizaciones: [],
      ListFracttal: [],
      ListLogistica: [],
      ListBodega: [],

      getUsuarios: "",
      dataPlantas: "",
      data_org: [],
      DocEntryOrganigrama: "",
    };
    this.onChange = this.onChange.bind(this);
  }


  get_data_usuarios = () => {
    const response = fetch(`${dominio}/getUsuarios`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },

    });

    response
      .then((res) => res.json(),)
      .then((data) => {
        console.log(data);
        let temp = [];
        data.forEach((element) => {
          temp.push(element);
        });
        this.setState({
          dataPlantas: temp,
        });
        // console.log(temp);

      })
      .catch((error) => {
        console.error('Error en la solicitud:', error);
      });

  };

  componentWillMount() {
    this.get_data_usuarios();
  }

  onChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      showReport: false,
    });

  };
  home = () => {
    if (document.getElementById("home").checked) {
      this.setState({
        showHome: true,
      });
    } else {
      this.setState({
        showHome: false,
      });
    }
  };

  Producction = () => {
    if (document.getElementById("production").checked) {
      this.setState({
        showProduction: true,
      });
    } else {
      this.setState({
        showProduction: false,
        listProduction: [],
      });
    }
  };

  Ventas = () => {
    if (document.getElementById("ventas").checked) {
      this.setState({
        showVentas: true,
      });
    } else {
      this.setState({
        showVentas: false,
        ListVentas: [],
      });
    }
  };

  Compras = () => {
    if (document.getElementById("compras").checked) {
      this.setState({
        showCompras: true,
      });
    } else {
      this.setState({
        showCompras: false,
        ListCompras: [],
      });
    }
  };

  Autorizaciones = () => {
    if (document.getElementById("autorizaciones").checked) {
      this.setState({
        showAutorizaciones: true,
      });
    } else {
      this.setState({
        showAutorizaciones: false,
        ListAutorizaciones: [],
      });
    }
  };

  Fracttal = () => {
    if (document.getElementById("fracttal").checked) {
      this.setState({
        showFracttal: true,
      });
    } else {
      this.setState({
        showFracttal: false,
        ListFracttal: [],
      });
    }
  };

  Logistica = () => {
    if (document.getElementById("logistica").checked) {
      this.setState({
        showLogistica: true,
      });
    } else {
      this.setState({
        showLogistica: false,
        ListLogistica: [],
      });
    }
  };

  Bodega = () => {
    if (document.getElementById("bodega").checked) {
      this.setState({
        showBodega: true,
      });
    } else {
      this.setState({
        showBodega: false,
        ListBodega: [],
      });
    }
  };


  onSelectProduction = (selectedList, selectedItem, All) => {
    this.setState({
      listProduction: selectedList,
    });
  };
  onRemoveProduction = (selectedList, removedItem) => {
    this.setState({
      listProduction: selectedList,
    });
  };



  onSelectVentas = (selectedList, selectedItem) => {
    this.setState({
      ListVentas: selectedList,
    });
  };
  onRemoveVentas = (selectedList, removedItem) => {
    this.setState({
      ListVentas: selectedList,
    });
  };

  onSelectCompras = (selectedList, selectedItem) => {
    this.setState({
      ListCompras: selectedList,
    });
  };
  onRemoveCompras = (selectedList, removedItem) => {
    this.setState({
      ListCompras: selectedList,
    });
  };


  onSelectAutorizaciones = (selectedList, selectedItem) => {
    this.setState({
      ListAutorizaciones: selectedList,
    });
  };
  onRemoveAutorizaciones = (selectedList, removedItem) => {
    this.setState({
      ListAutorizaciones: selectedList,
    });
  };

  onSelectFracttal = (selectedList, selectedItem) => {
    this.setState({
      ListFracttal: selectedList,
    });
  };
  onRemoveFracttal = (selectedList, removedItem) => {
    this.setState({
      ListFracttal: selectedList,
    });
  };

  onSelectLogistica = (selectedList, selectedItem) => {
    this.setState({
      ListLogistica: selectedList,
    });
  };
  onRemoveLogistica = (selectedList, removedItem) => {
    this.setState({
      ListLogistica: selectedList,
    });
  };

  onSelectBodega = (selectedList, selectedItem) => {
    this.setState({
      ListBodega: selectedList,
    });
  };
  onRemoveBodega = (selectedList, removedItem) => {
    this.setState({
      ListBodega: selectedList,
    });
  };

  data = () => {

    const { is_description, nombre, apellido, cargo, email } = this.state;


    const temp_listProduction = Object.entries(this.state.listProduction).length === 0;
    const temp_ListVentas = Object.entries(this.state.ListVentas).length === 0;
    const temp_ListCompras = Object.entries(this.state.ListCompras).length === 0;
    const temp_ListAutorizaciones = Object.entries(this.state.ListAutorizaciones).length === 0;
    const temp_ListFracttal = Object.entries(this.state.ListFracttal).length === 0;
    const temp_ListLogistica = Object.entries(this.state.ListLogistica).length === 0;
    const temp_ListBodega = Object.entries(this.state.ListBodega).length === 0;

    if (is_description === "seleccione un usuario") {
      return this.setState({
        message: "debe seleccionar un usuario",
      });
    }
    console.log(is_description);

    if (nombre === "") {
      return this.setState({
        message: "Ingrese nombre",
      });
    }

    if (apellido === "") {
      return this.setState({
        message: "Ingrese Apellido",
      });
    }
    if (cargo === "") {
      return this.setState({
        message: "Ingrese cargo",
      });
    }
    // if (email === "") {
    //   return this.setState({
    //     message: "Ingrese correo electronico",
    //   });
    // }

    if (
      document.getElementById("production").checked &&
      temp_listProduction === true
    ) {
      return this.setState({
        message: "seleccione un modulo para Produccion",
      });
    }


    if (document.getElementById("ventas").checked && temp_ListVentas === true) {
      return this.setState({
        message: "selecciones una vista para Ventas",
      });
    }
    if (document.getElementById("compras").checked && temp_ListCompras === true) {
      return this.setState({
        message: "selecciones un reporte para compras",
      });
    }
    if (document.getElementById("autorizaciones").checked && temp_ListAutorizaciones=== true) {
      return this.setState({
        message: "selecciones un reporte para autorizaciones",
      });
    }
    if (document.getElementById("fracttal").checked && temp_ListFracttal=== true) {
      return this.setState({
        message: "selecciones un reporte para Fracttal",
      });
    }
    if (document.getElementById("logistica").checked && temp_ListLogistica=== true) {
      return this.setState({
        message: "selecciones un reporte para Logistica",
      });
    }
    if (document.getElementById("bodega").checked && temp_ListBodega=== true) {
      return this.setState({
        message: "selecciones un reporte para Bodega",
      });
    }

    if (
      this.state.showProduction === false &&
      this.state.showVentas === false &&
      this.state.showCompras === false &&
      this.state.showAutorizaciones === false &&
      this.state.showFracttal === false  &&
      this.state.showLogistica === false &&
      this.state.showBodega === false

    ) {
      return this.setState({
        message: "seleccione un grupo de reporte",
      });
    }
    try {
      this.setState({
        message: "",
        isLoading: true,
      });
      const array_item_report = [];
      const array_groups_report = [];

      if (this.state.showHome === true) {
        array_groups_report.push(1);
      }
      if (this.state.showHome === false) {
        array_groups_report.push(0);
      }

      if (temp_listProduction === false) {
        array_groups_report.push(2);
        this.state.listProduction.forEach((element) => {
          array_item_report.push(parseInt(element.id));
        });
      }

      if (temp_ListVentas === false) {
        array_groups_report.push(3);

        this.state.ListVentas.forEach((element) => {
          array_item_report.push(parseInt(element.id));
        });
      }
      if (temp_ListCompras === false) {
        array_groups_report.push(11);

        this.state.ListCompras.forEach((element) => {
          array_item_report.push(parseInt(element.id));
        });
      }

      if (temp_ListAutorizaciones === false) {
        array_groups_report.push(12);

        this.state.ListAutorizaciones.forEach((element) => {
          array_item_report.push(parseInt(element.id));
        });
      }

      if (temp_ListFracttal === false) {
        array_groups_report.push(13);

        this.state.ListFracttal.forEach((element) => {
          array_item_report.push(parseInt(element.id));
        });
      }

      if (temp_ListLogistica === false) {
        array_groups_report.push(14);

        this.state.ListLogistica.forEach((element) => {
          array_item_report.push(parseInt(element.id));
        });
      }

      if (temp_ListBodega === false) {
        array_groups_report.push(15);

        this.state.ListBodega.forEach((element) => {
          array_item_report.push(parseInt(element.id));
        });
      }


      var username = "";
      var password = "";
      var User_Code = "";
      var User_Id = "";
      let token = localStorage.getItem("token");
      let token_Data = JSON.parse(token);
      if (token_Data !== null) {
        token_Data.forEach((element) => {
          username = element.usuarioSAP;
          password = element.contraseñaSAP;
          User_Code = element.user_code;
          User_Id = element.user_id;
        });
      }


      if (token_Data === null) {
        this.props.history.push("");
      }

      const response = fetch(`${dominio}/registrarUsuarios`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          password,
          is_description,
          nombre,
          apellido,
          cargo,
          email,
          array_groups_report,
          array_item_report,
          User_Code,
          User_Id
        }),
      });

      response
        .then((res) => res.json(),)
        .then((data) => {


          if (data[0].success) {

            // const tableDetails = JSON.parse(data[0]);

            // alert('Usuario registrado existosamente.');
            // window.location.reload();
            Swal.fire({
              icon: 'success',
              title: 'Exito',
              text: 'Usuario agregado exitosamente'
            }).then(() => {
              window.location.reload();
              return;
            });

            

          } else {

            // console.error('Error en la solicitud:', data[0].message);

            const errorMessage = data[0].message;         
         
          Swal.fire({
            icon: 'error',
            title: 'Error en la solicitud',
            text: errorMessage || 'Mensaje de error no disponible'
          }).then(() => {
            window.location.reload();
          });
          }

        })
        .catch((error) => {
          // console.error('Error en la solicitud:', error);
          const errorMessage = error;         
         
          Swal.fire({
            icon: 'error',
            title: 'Error en la solicitud',
            text: errorMessage || 'Mensaje de error no disponible'
          }).then(() => {
            window.location.reload();
          });
        });



    } catch (error) {
      this.setState({
        isLoading: false,
        message: "",
      });
    }
  };
  AllProduction = () => {
    this.setState({
      listProduction: produccion,
    });
  };
  AllVentas = () => {
    this.setState({
      ListVentas: ventas,
    });
  };
  AllCompras = () => {
    this.setState({
      ListCompras: compras,
    });
  };

  AllAutorizaciones = () => {
    this.setState({
      ListAutorizaciones: autorizaciones,
    });
  };

  AllFracttal = () => {
    this.setState({
      ListFracttal: fracttal,
    });
  };

  AllLogistica = () => {
    this.setState({
      ListLogistica: logistica,
    });
  };

  AllBodega = () => {
    this.setState({
      ListBodega: bodega,
    });
  };

  render() {
    const {
      nombre,
      apellido,
      email,
      cargo,
      isLoading,
      message,
      dataPlantas,
      is_description
    } = this.state;
    return (
      <div
        className="content"
        style={{ textAlign: "center", alignItems: "center" }}
      >
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="AGREGAR USUARIOS"
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content">
                    <div className="row">
                      <br />
                      <br />
                      <p>
                        <strong>INFORMACION DE USUARIO</strong>
                      </p>
                      <br />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="is_description">
                        Selecccione Usuario de SAP
                      </label>
                      <select
                        value={is_description}
                        name="is_description"
                        id="is_description"
                        className="form-control"
                        onChange={this.onChange}
                      >
                        <option key={""} value={""}>
                          {"seleccione un usuario"}
                        </option>
                        {dataPlantas &&
                          dataPlantas.map((res) => (
                            <option
                              key={res.user_id}
                              value={res.user_id}
                            >
                              {res.user_code}
                            </option>
                          ))}

                      </select>
                    </div>
                    <div className="row">
                      <br />
                      <br />
                      <br />
                      <br />
                      <div className="col-sm-3">
                        <ControlLabel>Nombre</ControlLabel>
                        <TextFieldGroup
                          field="nombre"
                          value={nombre}
                          onChange={this.onChange}
                          autoComplete="nombre"
                          placeholder={"nombre"}
                        />
                      </div>
                      <div className="col-sm-3">
                        <ControlLabel>Apellido</ControlLabel>
                        <TextFieldGroup
                          field="apellido"
                          value={apellido}
                          onChange={this.onChange}
                          autoComplete="apellido"
                          placeholder={"apellido"}
                        />
                      </div>
                      <div className="col-sm-3">
                        <ControlLabel>E-mail</ControlLabel>
                        <TextFieldGroup
                          field="email"
                          name="email"
                          type="email"
                          id="email"
                          value={email}
                          onChange={this.onChange}
                          autoComplete="email"
                          placeholder={"email"}
                        />
                      </div>
                      <div className="col-sm-3">
                        <ControlLabel>Cargo</ControlLabel>
                        <TextFieldGroup
                          field="cargo"
                          value={cargo}
                          onChange={this.onChange}
                          autoComplete="cargo"
                          placeholder={"cargo"}
                        />
                      </div>
                      
                    </div>
                    <div className="row">
                      <br />
                      <br />
                      <p>
                        <strong>Acceso a Vistas</strong>
                      </p>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <br />
                        <ListGroup>
                          <ListGroupItem>
                            <input
                              type="checkbox"
                              id="home"
                              name="home"
                              onClick={this.home}
                            />
                            <label htmlFor="home">&nbsp;&nbsp;Home</label>
                          </ListGroupItem>
                        </ListGroup>
                      </div>

                    </div>
                    <div className="row">

                      <div className="col-sm-3">
                        <br />
                        <ListGroup>
                          <ListGroupItem>
                            <input
                              type="checkbox"
                              id="production"
                              name="production"
                              onClick={this.Producction}
                            />
                            <label htmlFor="production">
                              &nbsp;&nbsp;PRODUCCION
                            </label>
                          </ListGroupItem>
                        </ListGroup>
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <ListGroup>
                          <ListGroupItem>
                            <input
                              type="checkbox"
                              id="ventas"
                              name="ventas"
                              onClick={this.Ventas}
                            />
                            <label htmlFor="ventas">&nbsp;&nbsp;Ventas</label>
                          </ListGroupItem>
                        </ListGroup>
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <ListGroup>
                          <ListGroupItem>
                            <input
                              type="checkbox"
                              id="compras"
                              name="compras"
                              onClick={this.Compras}
                            />
                            <label htmlFor="compras">&nbsp;&nbsp;Compras</label>
                          </ListGroupItem>
                        </ListGroup>
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <ListGroup>
                          <ListGroupItem>
                            <input
                              type="checkbox"
                              id="autorizaciones"
                              name="autorizaciones"
                              onClick={this.Autorizaciones}
                            />
                            <label htmlFor="autorizaciones">&nbsp;&nbsp;Autorizaciones</label>
                          </ListGroupItem>
                        </ListGroup>
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <ListGroup>
                          <ListGroupItem>
                            <input
                              type="checkbox"
                              id="fracttal"
                              name="fracttal"
                              onClick={this.Fracttal}
                            />
                            <label htmlFor="fracttal">&nbsp;&nbsp;Fracttal</label>
                          </ListGroupItem>
                        </ListGroup>
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <ListGroup>
                          <ListGroupItem>
                            <input
                              type="checkbox"
                              id="logistica"
                              name="logistica"
                              onClick={this.Logistica}
                            />
                            <label htmlFor="logistica">&nbsp;&nbsp;Logistica</label>
                          </ListGroupItem>
                        </ListGroup>
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <ListGroup>
                          <ListGroupItem>
                            <input
                              type="checkbox"
                              id="bodega"
                              name="bodega"
                              onClick={this.Bodega}
                            />
                            <label htmlFor="bodega">&nbsp;&nbsp;Bodega</label>
                          </ListGroupItem>
                        </ListGroup>
                      </div>


                    </div>
                    <div className="row">



                    </div>
                    <div className="row">


                    </div>

                    <div className="row">
                      <br />
                      {this.state.showProduction === true ? (
                        <div className="col-sm-6">
                          <ControlLabel> PRODUCCION</ControlLabel>
                          <br />
                          <Button
                            bsStyle="primary"
                            bsSize="small"
                            active
                            onClick={this.AllProduction}
                          >
                            Select All
                          </Button>
                          <br />
                          <br />
                          <Multiselect
                            options={produccion}
                            selectedValues={this.state.listProduction}
                            onSelect={this.onSelectProduction}
                            onRemove={this.onRemoveProduction}
                            displayValue="name"
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      {this.state.showVentas === true ? (
                        <div className="col-sm-6">
                          <ControlLabel>Ventas</ControlLabel>
                          <br />
                          <Button
                            bsStyle="primary"
                            bsSize="small"
                            active
                            onClick={this.AllVentas}
                          >
                            Select All
                          </Button>
                          <br />
                          <br />
                          <Multiselect
                            options={ventas}
                            selectedValues={this.state.ListVentas}
                            onSelect={this.onSelectVentas}
                            onRemove={this.onRemoveVentas}
                            displayValue="name"
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      {this.state.showCompras === true ? (
                        <div className="col-sm-6">
                          <ControlLabel>Compras</ControlLabel>
                          <br />
                          <Button
                            bsStyle="primary"
                            bsSize="small"
                            active
                            onClick={this.AllCompras}
                          >
                            Select All
                          </Button>
                          <br />
                          <br />
                          <Multiselect
                            options={compras}
                            selectedValues={this.state.ListCompras}
                            onSelect={this.onSelectCompras}
                            onRemove={this.onRemoveCompras}
                            displayValue="name"
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {this.state.showAutorizaciones === true ? (
                        <div className="col-sm-6">
                          <ControlLabel>Autorizaciones</ControlLabel>
                          <br />
                          <Button
                            bsStyle="primary"
                            bsSize="small"
                            active
                            onClick={this.AllAutorizaciones}
                          >
                            Select All
                          </Button>
                          <br />
                          <br />
                          <Multiselect
                            options={autorizaciones}
                            selectedValues={this.state.ListAutorizaciones}
                            onSelect={this.onSelectAutorizaciones}
                            onRemove={this.onRemoveAutorizaciones}
                            displayValue="name"
                          />
                        </div>
                      ) : (
                        ""
                      )}


                      {this.state.showFracttal === true ? (
                        <div className="col-sm-6">
                          <ControlLabel>Fracttal</ControlLabel>
                          <br />
                          <Button
                            bsStyle="primary"
                            bsSize="small"
                            active
                            onClick={this.AllFracttal}
                          >
                            Select All
                          </Button>
                          <br />
                          <br />
                          <Multiselect
                            options={fracttal}
                            selectedValues={this.state.ListFracttal}
                            onSelect={this.onSelectFracttal}
                            onRemove={this.onRemoveFracttal}
                            displayValue="name"
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {this.state.showLogistica === true ? (
                        <div className="col-sm-6">
                          <ControlLabel>Logistica</ControlLabel>
                          <br />
                          <Button
                            bsStyle="primary"
                            bsSize="small"
                            active
                            onClick={this.AllLogistica}
                          >
                            Select All
                          </Button>
                          <br />
                          <br />
                          <Multiselect
                            options={logistica}
                            selectedValues={this.state.ListLogistica}
                            onSelect={this.onSelectLogistica}
                            onRemove={this.onRemoveLogistica}
                            displayValue="name"
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {this.state.showBodega === true ? (
                        <div className="col-sm-6">
                          <ControlLabel>Bodega</ControlLabel>
                          <br />
                          <Button
                            bsStyle="primary"
                            bsSize="small"
                            active
                            onClick={this.AllBodega}
                          >
                            Select All
                          </Button>
                          <br />
                          <br />
                          <Multiselect
                            options={bodega}
                            selectedValues={this.state.ListBodega}
                            onSelect={this.onSelectBodega}
                            onRemove={this.onRemoveBodega}
                            displayValue="name"
                          />
                        </div>
                      ) : (
                        ""
                      )}


                    </div>









                    <div className="row">
                      <br />
                      <br />
                      <br />
                      <Button
                        bsStyle="primary"
                        bsSize="small"
                        active
                        onClick={this.data}
                      >
                        {" "}
                        agregar
                      </Button>
                      <p style={style.errorMessage}>{message}</p>
                    </div>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        {isLoading && <Loading />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(addUsers);
const style = {
  text: {
    textAlign: "center",
  },
  ColorCell: {
    textAlign: "center",
    backgroundColor: "#dddddd",
    border: "0px solid",
    color: "#000",
  },
  errorMessage: {
    fontWeight: "bold",
    fontSize: "12px",
    height: "10px",
    color: "red",
  },
};
